module.exports = __webpack_public_path__ + "assets/img/avatar_zebby.98db4859.png";